import {
  Badge,
  Card,
  CardContent,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { TicketAccordion } from '../Tickets'
import { styled } from '@mui/material/styles'
import config from '../../../config'

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    top: '8px',
    right: '-29px',
    padding: '8px 9px',
    fontSize: '12px',
  },
}))
const publicUrl = config.PUBLIC_URL

export const ProcessCard = ({
  coproprietaire,
  tickets,
  processName,
  linkable_type = 'tickets',
}) => {
  const useStyles = makeStyles({
    main_list: {
      '& > .RaList-main .MuiPaper-elevation': {
        boxShadow: 'none !important',
      },
    },
    icons: {
      width: '32px',
      marginRight: '8px',
    },
    processCard: {
      border: 'none',
      boxShadow: 'none',
      width: '100%',
      '& .MuiCardContent-root': {
        padding: '0 16px!important',
      },
      marginBottom: 10,
    },
  })
  const classes = useStyles()
  console.log({ tickets })
  return (
    <Card className={classes.processCard}>
      <CardContent
        style={{
          paddingBottom: '16px',
          paddingTop: 0,
        }}
      >
        <Typography
          variant="h5"
          component="h2"
          style={{
            marginTop: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            <img
              className={classes.icons}
              src={`${publicUrl + `/img/icons/competition.svg`}`}
            />
            {processName}
          </div>
        </Typography>
        <TicketAccordion
          coproprietaire={coproprietaire}
          linkable_type={linkable_type}
          archived={false}
          tickets={tickets}
          title={
            tickets?.filter((item) => !item.archived).length === 0 ? (
              'Aucune demande en cours'
            ) : (
              <StyledBadge
                badgeContent={tickets?.filter((item) => !item.archived).length}
                color="secondary"
              >
                Demandes en cours
              </StyledBadge>
            )
          }
        />
        <TicketAccordion
          coproprietaire={coproprietaire}
          archived={true}
          tickets={tickets}
          title={
            tickets?.filter((item) => item.archived).length === 0 ? (
              'Aucune demande en cours'
            ) : (
              <StyledBadge
                badgeContent={tickets?.filter((item) => item.archived).length}
                color="secondary"
              >
                Demandes archivées
              </StyledBadge>
            )
          }
        />
      </CardContent>
    </Card>
  )
}
export default ProcessCard
